import { get } from "lodash";
import { Box, Divider, H5 } from "orcs-design-system";
import React from "react";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { copywriting } from "src/pages/PersonDetailPage/PersonDetailPage.config";
import TagsEditorContainer from "src/components/TagsEditor";
import useHandleEntityTagClick from "src/hooks/useHandleEntityTagClick";
import { useOrgChartContext } from "src/components/OrgChart/context/OrgChartContext";
import useTagsVisibleInFilter from "src/app/Restricted/useTagsVisibleInFilter";
import { getName } from "src/util/person";
import useShowTagsEditor from "src/components/TagsEditor/utils/useShowTagsEditor";
import useUpdateTagsCache from "../hooks/useUpdateTagsCache";

const TagsEditor = () => {
  const tagsVisibleIn = useTagsVisibleInFilter();
  const { state } = useOrgChartContext() || {};
  const workspace = useWorkspace();
  const onEntityTagClick = useHandleEntityTagClick();

  const selectedPerson =
    state?.loadedMembers?.[state?.expandedPanel?.data?.selectedEntity];
  const aggregateId = get(selectedPerson, "aggregateId");
  const updateTagsCache = useUpdateTagsCache(aggregateId);

  const personTags = get(selectedPerson, "tags", []);

  const { showTagsEditor, isAllTagTypesReadOnly } =
    useShowTagsEditor(personTags);

  if (!showTagsEditor) {
    return null;
  }

  return (
    <Box>
      <Divider dash />
      <H5 mt="l" sizing="small" weight="bold" color="greyDark" uppercase>
        {copywriting.TAGS}
      </H5>
      <TagsEditorContainer
        entityType="person"
        entityId={aggregateId}
        entityName={getName(selectedPerson)}
        readOnly={isAllTagTypesReadOnly}
        updateCache={updateTagsCache}
        onEntityTagClick={onEntityTagClick}
        comments={{}}
        tagsVisibleIn={tagsVisibleIn}
        featureFlags={get(workspace, "config.featureFlags", {})}
      />
    </Box>
  );
};

export default React.memo(TagsEditor);
